import { IExpectedHoursItem } from "../services/types/expectedHours";
import appErrorToast from "../components/common/AppErrorToast";
import dataTimeService from "./dataTime.service";
import axiosInstance from "../utils/axios";
import { WorkTimeSettlement } from "./types/worktimeSettlement";

const pathPrefix = `${process.env.REACT_APP_SERVER_URL}/api`;

async function getWorkMinutesByUserForMonthTest(
  month: number,
  year: number
): Promise<WorkTimeSettlement[]> {
  const url = `${pathPrefix}/workItems?year=${year}&month=${month}`;
  return axiosInstance.get<WorkTimeSettlement[]>(url)
    .then((response) => {
      return Promise.resolve(response.data);
    });
}

export interface ISettlementActionPayload {
  userId: string;
  year: number;
  month: number;
}

export interface IRejectSettlementActionPayload extends ISettlementActionPayload {
  rejectionReason: string;
}

export async function getExpectedHoursForMonth(
  year: number,
  month: number
): Promise<IExpectedHoursItem[]> {
  try {
    const settlements = await getWorkMinutesByUserForMonthTest(month, year);

    return settlements.map((x) => {
      const timeToPay = (x.timeToPay100InMinutes ?? 0) + (x.timeToPay150InMinutes ?? 0) + (x.timeToPay200InMinutes ?? 0);
      const absentify = x.absentifyInMinutes ?? 0;
      const ignoredAbsentify = x.ignoredAbsentifyInMinutes ?? 0;
      const collected = x.collectedTimeInMinutes ?? 0;
      const workingHours = x.workingHoursInMinutes ?? 0;
      const toCollect = x.timeToCollectInMinutes ?? 0;

      return {
        id: `${x.userId}-${year}-${month}`,
        userId: x.userId,
        year,
        month,
        userName: `${x.lastName} ${x.firstName}`,
        youtrack: dataTimeService.convertMinutesToHours(x.workTimeInMinutes),
        absentify: dataTimeService.convertMinutesToHours(absentify),
        absentifyIgnored: dataTimeService.convertMinutesToHours(ignoredAbsentify),
        toCollectAndPay: dataTimeService.convertMinutesToHours(toCollect + timeToPay),
        collected: dataTimeService.convertMinutesToHours(collected),
        timePaidout100: dataTimeService.convertMinutesToHours(x.timeToPay100InMinutes ?? 0),
        timePaidout150: dataTimeService.convertMinutesToHours(x.timeToPay150InMinutes ?? 0),
        timePaidout200: dataTimeService.convertMinutesToHours(x.timeToPay200InMinutes ?? 0),
        workingHours: dataTimeService.convertMinutesToHours(workingHours),
        total: dataTimeService.convertMinutesToHours(x.workTimeInMinutes + absentify + timeToPay + collected),
        target: dataTimeService.convertMinutesToHours(workingHours + absentify + timeToPay + collected),
        settlementStatus: x.settlementStatus,
        rejectionReason: x.rejectionReason ?? "",
        decisionAt: x.decisionAt,
        decisionByUserId: x.decisionByUserId,
        isValuesConsistent: x.isValuesConsistent,
      }
    })
  } catch (error) {
    appErrorToast(`Błąd w pobieraniu danych rozliczenia: ${error}`);
    return [];
  }
}

export async function acceptSettlement(payload: ISettlementActionPayload): Promise<void> {
  try {
    const url = `${pathPrefix}/workItems/${payload.userId}/settlement/accept?year=${payload.year}&month=${payload.month}`;
    await axiosInstance.put(url);
  } catch (error) {
    appErrorToast(`Błąd podczas akceptacji rozliczenia: ${error}`);
    throw error;
  }
}

export async function rejectSettlement(payload: IRejectSettlementActionPayload): Promise<void> {
  try {
    const url = `${pathPrefix}/workItems/${payload.userId}/settlement/reject?year=${payload.year}&month=${payload.month}`;
    await axiosInstance.put(url, { rejectionReason: payload.rejectionReason });
  } catch (error) {
    appErrorToast(`Błąd podczas odrzucania rozliczenia: ${error}`);
    throw error;
  }
}